import React from 'react';
import { MediaStatus } from '../../../hooks/useMediaAttachment';

interface MediaOverlayProps {
    status: MediaStatus;
    typeLabel: string;
    icon: React.ReactNode;
    onClick: (e: React.MouseEvent) => void;
}

export const MediaOverlay: React.FC<MediaOverlayProps> = ({
                                                              status,
                                                              typeLabel,
                                                              icon,
                                                              onClick
                                                          }) => {
    // Si la descarga fue exitosa, no mostramos el overlay para permitir ver el contenido (Sticker/Imagen)
    if (status === 'SUCCESS') return null;

    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center position-absolute w-100 h-100 text-white"
            style={{
                top: 0,
                left: 0,
                zIndex: 10,
                cursor: status === 'LOADING' ? 'default' : 'pointer',
                borderRadius: 'inherit',
                background: 'rgba(0,0,0,0.45)', // Un fondo semi-transparente oscuro
                transition: 'background 0.3s ease'
            }}
            onClick={(e) => {
                e.stopPropagation();
                if (status !== 'LOADING') onClick(e);
            }}
        >
            {status === 'LOADING' ? (
                <div className="d-flex flex-column align-items-center">
                    <div className="spinner-border text-light mb-2" role="status" style={{ width: '1.5rem', height: '1.5rem' }}>
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                    <span style={{ fontSize: '12px', fontWeight: 500 }}>Cargando...</span>
                </div>
            ) : status === 'ERROR' ? (
                <div className="d-flex flex-column align-items-center text-center px-2">
                    <div className="rounded-circle bg-dark bg-opacity-75 d-flex justify-content-center align-items-center mb-1"
                         style={{ width: '42px', height: '42px' }}>
                        <i className="ri-refresh-line fs-20"></i>
                    </div>
                    <span style={{ fontSize: '11px', fontWeight: 500 }}>Error al cargar</span>
                    <span style={{ fontSize: '10px', opacity: 0.8 }}>Click para reintentar</span>
                </div>
            ) : (
                /* Estado IDLE: Botón de descarga inicial */
                <div className="d-flex flex-column align-items-center text-center px-2">
                    <div className="rounded-circle bg-dark bg-opacity-75 d-flex justify-content-center align-items-center mb-2"
                         style={{ width: '45px', height: '45px' }}>
                        <i className="ri-download-2-line fs-22"></i>
                    </div>
                    <span style={{ fontSize: '12px', fontWeight: 500 }}>
                        {icon} Descargar {typeLabel}
                    </span>
                </div>
            )}
        </div>
    );
};
